var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.533,
    height: 16.588,
    viewBox: "0 0 20.533 16.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image",
    d: "M119.943,92.25h15.833a2.358,2.358,0,0,1,2.35,2.35v11.888a2.358,2.358,0,0,1-2.35,2.35H119.943a2.358,2.358,0,0,1-2.35-2.35V94.6a2.358,2.358,0,0,1,2.35-2.35Zm13.823,3.3a1.437,1.437,0,1,1-1.437,1.437A1.437,1.437,0,0,1,133.767,95.547Zm-2.4,3.67,4.857,6.109c.464.583.166,1.648-.645,1.648H120.138a1.007,1.007,0,0,1-.645-1.648l3.127-3.933a1.232,1.232,0,0,1,1.995,0l1.514,1.9,3.244-4.08a1.232,1.232,0,0,1,1.995,0Z",
    transform: "translate(-117.593 -92.25)",
    fill: "rgba(0,0,0,0.4)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.304e21c9e72c2eeb5249550cd7c08d5f.svg";
export { ForwardRef as ReactComponent };